import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { BaseService } from 'src/app/services/common/base.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-vendor-all-applications',
  templateUrl: './vendor-all-applications.component.html',
  styleUrls: ['./vendor-all-applications.component.scss']
})
export class VendorAllApplicationsComponent implements OnInit {
  display: boolean = false;  
  viewApplicationWorkFlowDiag = false;  
  statusData: string = 'Your application status is...';  
  selectedAppId: string | null = null;
  exportMenu: MenuItem[];

 showDialog(row) {
  this.selectedAppId = row?.APP_ID; 
  this.viewApplicationWorkFlowDiag = true; 
  this.display = true; 
}
onApplicationSelect(appId: string) {
    this.selectedAppId = appId;                
    this.viewApplicationWorkFlowDiag = true;  
    this.display = true;                     
  }


  public tableData: any = [];
  public tableHeaderName = 'All Farmer Applications';

  public subscriptions: any = [];
  public subjectSub:any;
  public loading: boolean = false;
  public userId: any;

  constructor(
    private messageService: MessageService, 
    private cryptoJsService: CryptoJsService, 
    private ipService: IpAddressService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private vendorService: VendorDashboardService,
    private router: Router, 
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    // this.vendorRegId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.exportMenu = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.tableData, `MI_${this.tableHeaderName}`);
        },
      }
    ];

    this.loadData();
  }


  loadData() {
    this.loading = true;

    let sub = this.vendorService
      .getAllAppIdsByVendor(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data?.length > 0) {
            this.tableData = data;
          } else {
            this.tableData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.loading = false;
          this.tableData = [];
         
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }



  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP Id': d.APP_ID,
          'Status': d.FarmerStatus,
          'Farmer Name': d.farmerName,
          'App Type': d.Applicant_type,
          'Constituency': d.Constituency,
          'District': d?.District,
          'Block': d?.Block,
          'Village': d?.Village,
          'Scheme': d.Scheme,
          'KYC Status': d.KYC_Status
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  rowBackgroundColor(row) {
    if (row.FarmerStatus == 'A') {
      //light green
      return '#99e699'
    } 
    else if (row.FarmerStatus == 'P') {
      // light yellow
      return '#ffffc5'
    } 
    else if (row.FarmerStatus == 'R') {
      //red
      return '#ff8080';
    } 
    else if (row.FarmerStatus == 'RP') {
      //orange
      return '#ffc966';
    } 
    else return '#ffffff';
  }

  selectFarmerApplication(application) {
    if (application?.APP_ID) {
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.APP_ID.toString()) } }));
      window.open(link, '_blank');
    }
    else{
      this.messageService.add({
        summary: 'Error Message',
        severity: 'info',
        detail: 'Application Id Not Found',
      });
    }
  }

}
